<template>
  <div class="animated fadeIn brief-tarea-abm">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-form>
            <b-form-group
              label="Título"
              label-for="titulo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titulo"
                v-model.trim= "$v.titulo.$model" 
                :state="tituloValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="tituloFeedback">
                {{ tituloInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="descripcion"
                v-model="$v.descripcion.$model" 
                rows="3"
                max-rows="3"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Entrega"
              label-for="fechaEntrega"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaEntrega" 
                v-model="fechaEntrega" 
                type="date">
              </b-form-input>
            </b-form-group>

            <app-prioridad
              label="Prioridad"
              :nombre="prioridadNombre"
              :valido="prioridadValida"
              :lista="prioridadesList"
              :msjInvalido="prioridadInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="prioridadActualizada">
            </app-prioridad>  

            <app-estado
              label="Estado"
              :nombre="briefTareaEstadoNombre"
              :valido="briefTareaEstadoValido"
              :lista="estadosList"
              :msjInvalido="briefTareaEstadoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="briefTareaEstadoActualizado">
            </app-estado>

            <b-form-group
              label="Responsable"
              label-for="usuario"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarUsuario">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !usuario,
                                  'fa fa-remove': usuario  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="usuario"
                  :value="usuarioNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cerrar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchUsuarioModal" 
        title="Seleccionar Responsable"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-usuario
        :asignaTareasBrief="true"
        @itemSeleccionado="usuarioSeleccionado">
      </app-search-usuario>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Prioridad from '../shared/abmSelect.vue';
import Estado from '../shared/abmSelect.vue';
import SearchUsuario from '../usuarios/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefTarea/getField',
  mutationType: 'briefTarea/updateField',
});

export default {
  name: 'BriefsTareasABM',
  props: {
    briefId: {
      type: Number,
      default: 0
    },
    briefTareaId: {
      type: Number,
      default: 0
    },
  },
  components: {
    appPrioridad: Prioridad,
    appEstado: Estado,
    appSearchUsuario: SearchUsuario,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      tituloValido: null,
      tituloInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      prioridadValida: null,
      prioridadInvalidaMsj: '',
      briefTareaEstadoValido: null,
      briefTareaEstadoInvalidoMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'titulo',
      'descripcion',
      'prioridad',
      'prioridadNombre',
      'briefTareaEstado',
      'briefTareaEstadoNombre',
      'fechaEntrega',
      'usuario',
      'usuarioNombre',

      'prioridades',
      'prioridadesList',
      'estados',
      'estadosList'
    ]),
  },  
  created() {
    let params = {
      briefId: this.briefId,
      briefTareaId: this.briefTareaId
    }

    this.showSpinner();
    this.$store.dispatch('briefTarea/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  }, 
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titulo' || validarTodos) {
        if (this.$v.titulo.$error) {
          this.tituloValido = false;
          if (!this.$v.titulo.required) {
            this.tituloInvalidoMsj= 'Debe ingresar el título de la tarea.';
          } else if (!this.$v.titulo.maxLength) {
            this.tituloInvalidoMsj = 'El título sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.tituloValido = null;
          this.tituloInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let prioridadError = true;
      if (this.prioridad) {
        if (this.prioridad.id) {
          if (this.prioridad.id != 0) {
            prioridadError = false;
          }
        }
      }
      if (prioridadError) {
        this.prioridadValida = false;
        this.prioridadInvalidaMsj = 'Debe seleccionar la prioridad correspondiente';
        save = false;
      }

      let errorEstado = true;
      if (this.briefTareaEstado) {
        if (this.briefTareaEstado.id) {
          if (this.briefTareaEstado.id != 0) {
            errorEstado = false;
          }
        }
      }
      if (errorEstado) {
        this.briefTareaEstadoValido = false;
        this.briefTareaEstadoInvalidoMsj = 'Debe seleccionar el estado correspondiente.';
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('briefTarea/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      let briefTarea = this.$store.getters['briefTarea/briefTarea'];
      
      this.$emit('saved', briefTarea);
    },
    close() {
      this.$emit('canceled');
    },
    briefTareaEstadoActualizado(estadoNombre) {
      let estado;
      if (estadoNombre) {
        estado = this.getSelected(this.estados, estadoNombre);
      }
      this.$store.dispatch('briefTarea/setEstado', estado);

      this.briefTareaEstadoValido = null;
      this.briefTareaEstadoInvalidoMsj = '';
    },
    prioridadActualizada(prioridadNombre) {
      let prioridad;
      if (prioridadNombre) {
        prioridad = this.getSelected(this.prioridades, prioridadNombre);
      }
      this.$store.dispatch('briefTarea/setPrioridad', prioridad);

      this.prioridadValida = null;
      this.prioridadInvalidaMsj = '';
    },
    seleccionarUsuario() {
      if (this.usuario) {
        this.$store.dispatch('briefTarea/setUsuario', null);
      }
      this.$refs.searchUsuarioModal.show();
    },
    usuarioSeleccionado(usuario) {
      this.$refs.searchUsuarioModal.hide();
        this.$store.dispatch('briefTarea/setUsuario', usuario)
          .catch(error => this.showErrorMsj(error));
    },
  },
  watch: {
  },    
  validations: {
    titulo: {
      required,
      maxLength: maxLength(150)
    },
    descripcion: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>
